import { render, staticRenderFns } from "./PhoneSVG.vue?vue&type=template&id=05c126e4&"
import script from "./PhoneSVG.vue?vue&type=script&lang=js&"
export * from "./PhoneSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports